/**
 * @type {HTMLFormElement}
 */
const form = document.querySelector(`.feedback-form`);

form.addEventListener(`input`, updateFormData);
form.addEventListener(`submit`, handelSubmit);

let formData = {};

if (localStorage.getItem(`feedback-form-state`) === null) {
  formData = {
    email: ``,
    message: ``,
  };
  console.log(`t`);
} else {
  formData = JSON.parse(localStorage.getItem(`feedback-form-state`));
  form.elements.email.value = formData.email;
  form.elements.message.value = formData.message;
}

function updateFormData(event) {
  const input = event.target.name;
  const message = event.target.value.trim();
  formData[input] = message;
  window.localStorage.setItem(`feedback-form-state`, JSON.stringify(formData));
}

function handelSubmit(event) {
  event.preventDefault();

  if (formData[`email`] === '' || formData[`message`] === '') {
    alert(`All form fields must be filled in`);
    return;
  }
  console.log(formData);
  formData = {
    email: ``,
    message: ``,
  };
  localStorage.removeItem(`feedback-form-state`);
  form.reset();
}
